import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TemplatesComponent } from './templates.component';
import { AddTemplateComponent, CheckDemoDialog } from './add-template/add-template.component';
import { EditTemplateComponent } from './edit-template/edit-template.component';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatInputModule} from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import { PipeModule } from '../pipes/pipe/pipe.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AlertModule } from '../alert/alert.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

const routes: Routes = [
      {
        path: '',
        component: TemplatesComponent,
      },
      {
        path: 'add',
        component: AddTemplateComponent,
      },
      {
        path: 'edit/:id',
        component: EditTemplateComponent,
      }
];

@NgModule({
    declarations: [
        TemplatesComponent,
        AddTemplateComponent,
        EditTemplateComponent,
        CheckDemoDialog
    ],
    imports: [
        RouterModule.forChild(routes),
        MatIconModule,
        MatCardModule,
        FlexLayoutModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        MatGridListModule,
        MatRadioModule,
        MatSelectModule,
        MatTooltipModule,
        TooltipModule,
        AlertModule,
        NgbModule,
        MatProgressSpinnerModule,
        PipeModule
    ],
    exports: [RouterModule]
})
export class TemplateRoutingModule {}